import axios from 'axios';

export default {
  namespaced: true,
  state: {
    status: 'init',
    wojewodztwa: [],
  },
  getters: {
    wojewodztwa: state => state.wojewodztwa,
    powiaty: (state, getters) => {
      let powiaty = []
      getters.wojewodztwa.forEach(w => {
        powiaty = powiaty.concat(w.powiaty)
      })
      return powiaty
    },
    gminy: (state, getters) => {
      let gminy = []
      getters.powiaty.forEach(w => {
        gminy = gminy.concat(w.gminy)
      })
      return gminy
    },
    powiatById: (state, getters) => id => getters.powiaty.find(powiat => powiat.id == id),
    gminaById: (state, getters) => id => getters.gminy.find(gmina => gmina.id == id),
  },
  mutations: {
    set(state, { status, wojewodztwa }) {
      state.status = status
      state.wojewodztwa = wojewodztwa
    },
    setStatus(state, { status }) {
      state.status = status
    },
  },
  actions: {
    download(ctx) {
      return new Promise((resolve, reject) => {
        ctx.commit('setStatus', { status: 'loading' })
        axios.get("/jst_pub/tree")
          .then(r => {
            ctx.commit('set', {
              status: 'loaded',
              wojewodztwa: r.data.wojewodztwa,
            })
            resolve(r)
          })
          .catch(e => {
            ctx.commit('setStatus', { status: 'failure' })
            console.error(e)
            reject(e)
          })
      })
    }
  }
}
